module.exports = "<div>\n    <rm-date-time-picker toggle=\"true\" ng-model=\"value\"></rm-date-time-picker>\n</div>\n";